export default __webpack_public_path__ + "static/media/img_step_lucia03-01.1c80e570.jpg";